import { MeetingHistoryActions } from './types';
import { API } from '../../../vendor/api';
import { selectInstitution } from '../system';
export const getMeetingHistoryByParams = ({ start, end, offset, limit, providersIds = [], roomsIds = [], locationIds = [], }) => async (dispatch, getState) => {
    try {
        const institution = selectInstitution(getState());
        const institutionId = institution ? institution.id : null;
        dispatch({
            type: MeetingHistoryActions.SET_MEETING_HISTORY_IS_LOADING,
            payload: true,
        });
        // Unless datepicker not ready we show all meeting history records
        // After adding datepicker add to request start, end, parameters
        const meetingHistory = await API.meetingHistory.getMeetingHistoryByParams({
            institutionId,
            userIds: providersIds,
            roomIds: roomsIds,
            locationIds: locationIds,
            offset,
            limit,
            start,
            end,
        });
        dispatch({
            type: MeetingHistoryActions.GET_MEETING_HISTORY,
            payload: meetingHistory,
        });
        dispatch({
            type: MeetingHistoryActions.SET_MEETING_HISTORY_IS_LOADING,
            payload: false,
        });
    }
    catch (e) {
        console.error('Error in action "getMeetingHistory": ', e);
    }
};
